import React,{useEffect} from 'react'
import Navbar from './Navbar'
import Home from './components/Home'
import About from './components/About'
import Skills from './components/Skills'
import Works from './components/Works'
import ContactForm from './components/ContactForm'
import { Route, Switch } from 'react-router-dom'
import sun from './images/sun.svg'
import $ from 'jquery'
//we used App.js for routing the page

//sun css
let suncss={
  maxWidth:"250px",
  position:"fixed",
  left:"30%",
  bottom:"0px",
  animation:"animsun 1.5s ease normal",
  transform:"scale(1.2)"
}

function App() {
  useEffect(()=>{
    //when menubar of hamberger appear this code will push it back to top
    //jQuery code
    $(window).resize(function(){
        if ($(window).width() <= 390) {//if  screen is md means menu will appear
          $('#suncss').css({
            maxWidth:"150px",
            left:"0px",
          })
        }
        else{
          $('#suncss').css({
            maxWidth:"250px",
            left:"30%",
          })
        }
      })
      if ($(window).width() <= 390) {//if  screen is md means menu will appear
        $('#suncss').css({
          maxWidth:"150px",
          left:"0px",
        })
      }
      else{
        $('#suncss').css({
          maxWidth:"250px",
          left:"30%",
        })
      }
})
  return (
    <>
    {/* making svg hide and show if current page is home page
      {location.pathname !== '/components/Works' || location.pathname === '/components/Skills' ? */}
      <img src={sun} alt="" id="suncss" style={suncss}/>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 300"><path fill="#0099ff" fill-opacity="1" d="M0,288L48,266.7C96,245,192,203,288,192C384,181,480,203,576,176C672,149,768,75,864,42.7C960,11,1056,21,1152,58.7C1248,96,1344,160,1392,192L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
         {/* : null} */}
      <div className="container">
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/components/About" component={About} />
          <Route exact path="/components/Skills" component={Skills} />
          <Route exact path="/components/Works" component={Works} />
          <Route exact path="/components/ContactForm" component={ContactForm} />
        </Switch>
      </div>
    </>
  )
}

export default App